const storageKey = "estate-platform:theme";

type Theme = "dark" | "light";

const isTheme = (value: string | null | undefined): value is Theme => value === "dark" || value === "light";

const themeOf = (root: HTMLElement): Theme => {
  const chosen = root.dataset["theme"];
  if (isTheme(chosen)) {
    return chosen;
  }
  return matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

// WHY: the theme is a device preference like the property context; blocked storage just leaves the system theme.
const storedTheme = (): string | null => {
  try {
    return localStorage.getItem(storageKey);
  } catch {
    return null;
  }
};

export const applyStoredTheme = (): void => {
  const stored = storedTheme();
  if (isTheme(stored)) {
    document.documentElement.dataset["theme"] = stored;
  }
};

export const toggleTheme = (): void => {
  const root = document.documentElement;
  const next = themeOf(root) === "dark" ? "light" : "dark";
  root.dataset["theme"] = next;
  try {
    localStorage.setItem(storageKey, next);
  } catch {
    // WHY: the choice then lasts until the page reloads.
  }
};
